"use strict";
/**
 *
 * @param isMinorNameChangeEnabled - Boolean value which tells if minorNameChange is enabled in region or not.
 * @returns status
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMinorNameChangeEnabled = void 0;
function isMinorNameChangeEnabled(features) {
    return features.minorNameChange;
}
exports.isMinorNameChangeEnabled = isMinorNameChangeEnabled;
